/**
 * 렌더러 팩토리. 구현체는 'konva' 하나이고 기본값이다.
 */
import type { IRenderer } from './IRenderer'
import type { RendererKind, RendererOptions } from './types'
import { KonvaRenderer } from './konva/KonvaRenderer'

export const DEFAULT_RENDERER_KIND: RendererKind = 'konva'

export function resolveRendererKind(kind?: RendererKind): RendererKind {
  return kind ?? DEFAULT_RENDERER_KIND
}

export function createRenderer(opts: RendererOptions): IRenderer {
  const kind = resolveRendererKind(opts.kind)
  switch (kind) {
    case 'konva':
      return KonvaRenderer.create({
        container: opts.container,
        width: opts.width,
        height: opts.height,
      })
  }
}
